import { ASSET_PROFILE_NAV_EVENT_MAP, GearbeltEvent } from '@gearbelt/global';
import { useLocation, useParams } from 'react-router-dom';

import CalendarBlankIcon from '@/components/icons/calendar-blank';
import FolderClosedIcon from '@/components/icons/folder-closed';
import FormChecklistIcon from '@/components/icons/form-checklist';
import FormPortraitIcon from '@/components/icons/form-portrait';
import GaugeIcon from '@/components/icons/gauge';
import InformationIcon from '@/components/icons/information';
import MapIcon from '@/components/icons/map';
import SpannerIcon from '@/components/icons/spanner';
import WarningTriangleIcon from '@/components/icons/warning-triangle';
import { ButtonStateToggleVertical } from '@/components/ui/button-state-toggle-vertical';
import { useEvents } from '@/utils/events';
import { useWorkspaceNavigate } from '@/utils/routes';

export function AssetNavTabs() {
  const { pathname } = useLocation();
  const { id } = useParams();
  const navigate = useWorkspaceNavigate();
  const { trackEvent } = useEvents();

  const pathSegments = pathname.split('/');
  const idIndex = pathSegments.indexOf(id || '');
  const tabSegments = idIndex !== -1 ? pathSegments.slice(idIndex + 1) : [];
  const tab = tabSegments.length > 0 ? tabSegments.join('/') : '';

  return (
    <div className="border-r-grey-3 sticky top-0 h-[calc(100vh-54px)] w-[240px] min-w-[240px] border-r bg-white p-2">
      <ButtonStateToggleVertical
        options={[
          { icon: <InformationIcon />, label: 'Overview', value: '' },
          { icon: <FolderClosedIcon />, label: 'Documents', value: 'documents' },

          { icon: <FormChecklistIcon />, label: 'Inspection Records', value: 'inspections' },
          { icon: <WarningTriangleIcon />, label: 'Issues', value: 'issues' },
          { icon: <FormPortraitIcon />, label: 'Repair Records', value: 'repairs' },
          { icon: <SpannerIcon />, label: 'Schedule Checks', value: 'schedule-checks' },
          { icon: <FormPortraitIcon />, label: 'Schedule Form Records', value: 'schedule-form-records' },
          { icon: <CalendarBlankIcon />, label: 'Work Orders', value: 'work-orders' },
          { icon: <MapIcon />, label: 'Location Logs', value: 'location-logs' },
          { icon: <GaugeIcon />, label: 'Reading Logs', value: 'reading-logs' },
        ]}
        value={tab}
        onChange={(value) => {
          trackEvent(GearbeltEvent.AssetNavigationSelected, {
            Context: ASSET_PROFILE_NAV_EVENT_MAP[value || ''],
          });
          navigate(`/assets/${id}/${value}`);
        }}
      />
    </div>
  );
}
